import { Component, OnInit } from '@angular/core';
import {PersonService} from '../person.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private personService:PersonService) { }
  test='This is a test'
  person;
  c:boolean=false;
  onSalutationsComplete()
  {
    this.c=true;
  }
  ngOnInit() {
    this.person=this.personService.getPerson();
  }

}
